/**
 * QuickOrderBundlesPage - Redirects to canonical bundle management location
 * 
 * Bundle management is now consolidated in Product Config → Quick Bundles tab.
 * This page redirects there to maintain any existing bookmarks/links.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function QuickOrderBundlesPage() {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to Product Config page with bundles tab active
    navigate('/admin/product-config/flows?tab=bundles', { replace: true });
  }, [navigate]);
  
  return null;
}
